<template>
  <v-layout row wrap align-center >
    <v-flex xs12 sm8 m6 l4 class="text-xs-center">
      <span class="display-4">404</span><br>
      <span class="display-2">Page Not Found</span>
      <v-btn @click.stop="goHome" color="primary">Go Home</v-btn>
    </v-flex>
  </v-layout>
  
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  methods: {
    goHome: function () {
      if (this.currentUser) {
        if (this.userProfile.admin) {
          this.$router.push({name: 'Dashboard'})
        } else {
          this.$router.push({name: 'Home'})
        }
      } else {
        this.$router.push('/login')
      }
    }
  },
  computed: mapGetters({
    currentUser: 'currentUser',
    userProfile: 'userProfile'
  })
}
</script>
<style scoped>
  .list {
    width: 100%;
    padding: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/404View.vue